import { Typography, type TypographyProps } from '@mui/material';
import { MessageKey, useI18n } from '../i18n';

interface TranslatedTextProps extends Omit<TypographyProps, 'children'> {
  messageKey: MessageKey;
  params?: Record<string, string | number>;
}

export function TranslatedText({
  messageKey,
  params,
  ...typographyProps
}: TranslatedTextProps) {
  const { t } = useI18n();

  return (
    <Typography
      {...typographyProps}
      data-message-key={import.meta.env.DEV ? messageKey : undefined}
    >
      {t(messageKey, params)}
    </Typography>
  );
}
